// const base_url = "https://equipped-trains-pain-rope.trycloudflare.com";
const base_url = "https://cashback.webplanex.com";
// const base_url = "https://cashbackdemo.webplanex.com";

const LOGIN = base_url + "/api/login";
const CHECK_AUTH = base_url + "/api/check-auth";
const LOGOUT = base_url + "/api/logout";
const GET_ORDERS = base_url + "/api/get-orders";
const GET_FULFILLED_ORDERS = base_url + "/api/get-fulfilled-orders";
const GET_DELIVERED_ORDERS = base_url + "/api/get-delivered-orders";
const GET_CUSTOMERS = base_url + "/api/get-customers";
const PROCESS_ORDER = base_url + "/api/process-order";
const PROCESS_FULFILLED_ORDER = base_url + "/api/process-fulfilled-order";
const PROCESS_DELIVERED_ORDER = base_url + "/api/process-delivered-order";
const PROCESS_CUSTOMER = base_url + "/api/process-customer";
const GET_SHOPS = base_url + "/api/get-shops";
const GET_FAILED_ORDERS = base_url + "/api/get-failed-orders";
const GET_FAILED_FULFILLED_ORDERS = base_url + "/api/get-failed-fulfilled-orders";
const GET_FAILED_DELIVERED_ORDERS = base_url + "/api/get-failed-delivered-orders";
const GET_FAILED_ORDERS_EMAILS = base_url + "/api/get-failed-orders-emails";
const PROCESS_FAILED_ORDER = base_url + "/api/process-failed-order";
const PROCESS_FAILED_FULFILLED_ORDER = base_url + "/api/process-failed-fulfilled-order";
const PROCESS_FAILED_DELIVERED_ORDER = base_url + "/api/process-failed-delivered-order";
const GET_TRACKED_DATA = base_url + "/api/get-tracked-data";
const GET_ACTIVE_STORES = base_url + "/api/get-active-stores";
const GET_INACTIVE_STORES = base_url + "/api/get-in-active-stores";
const GET_DEMO_STORES = base_url + "/api/get-demo-stores";
const FETCH_CASHBACK_LIST = base_url + "/api/fetch-cashback-list";
const GET_ACTIVITY_LOGS = base_url + "/api/get-activity-logs";
const SAVE_CUSTOM_PLAN = base_url + "/api/save-custom-plan";
const CUSTOM_PLAN_LIST = base_url + "/api/custom-plan-list";
const DELETE_CUSTOM_PLAN = base_url + "/api/delete-custom-plan";
const GET_EXHUST_STORE_LIST = base_url + "/api/get-exhust-store-list";
const GET_PLAN_STORE_HISTRY = base_url + "/api/get-plan-store-history";
const SEARCH_PLAN_STORE_HISTRY = base_url + "/api/search-plan-store-history";
const ALL_STORE_HISTRY = base_url + "/api/all-store-history";
const DELETE_FAILED_ORDER_DB = base_url + "/api/delete-failed-order-db";
const DELETE_MULTIPLE_FAILED_ORDER_EMAILS = base_url + "/api/delete-multiple-failed-order-emails";
const MARK_ORDER_AS_PROCESSED = base_url + "/api/mark-order-as-processed";
const MARK_ORDER_FULFILLED_AS_PROCESSED = base_url + "/api/mark-order-fulfilled-as-processed";
const MARK_ORDER_DELIVERED_AS_PROCESSED = base_url + "/api/mark-order-delivered-as-processed";
const GET_DASHBOARD_DATA = base_url + "/api/get-dashboard-data";
const GET_COUNTS = base_url + "/api/get-counts";
const GET_FULFILLED_COUNTS = base_url + "/api/get-fulfilled-counts";
const GET_DELIVERED_COUNTS = base_url + "/api/get-delivered-counts";
const SEND_REMINDER_EMAIL = base_url + "/api/send-reminder-email";
const GET_ALL_DB_CONNECTIONS = base_url + "/api/getconnections";
const SAVE_CASHBACKAPI_ENABLED = base_url + "/api/save-cashbackapi-enabled";


export {
  LOGIN,
  CHECK_AUTH,
  LOGOUT,
  GET_ORDERS,
  GET_FULFILLED_ORDERS,
  GET_DELIVERED_ORDERS,
  GET_CUSTOMERS,
  PROCESS_ORDER,
  PROCESS_FULFILLED_ORDER,
  PROCESS_DELIVERED_ORDER,
  PROCESS_CUSTOMER,
  GET_SHOPS,
  GET_FAILED_ORDERS,
  GET_FAILED_ORDERS_EMAILS,
  GET_FAILED_FULFILLED_ORDERS,
  GET_FAILED_DELIVERED_ORDERS,
  PROCESS_FAILED_ORDER,
  PROCESS_FAILED_FULFILLED_ORDER,
  PROCESS_FAILED_DELIVERED_ORDER,
  GET_TRACKED_DATA,
  GET_ACTIVE_STORES,
  GET_INACTIVE_STORES,
  GET_DEMO_STORES,
  FETCH_CASHBACK_LIST,
  GET_ACTIVITY_LOGS,
  SAVE_CUSTOM_PLAN,
  CUSTOM_PLAN_LIST,
  DELETE_CUSTOM_PLAN,
  DELETE_FAILED_ORDER_DB,
  DELETE_MULTIPLE_FAILED_ORDER_EMAILS,
  MARK_ORDER_AS_PROCESSED,
  MARK_ORDER_FULFILLED_AS_PROCESSED,
  MARK_ORDER_DELIVERED_AS_PROCESSED,
  GET_DASHBOARD_DATA,
  GET_COUNTS,
  GET_FULFILLED_COUNTS,
  GET_DELIVERED_COUNTS,
  SEND_REMINDER_EMAIL,
  GET_ALL_DB_CONNECTIONS,
  GET_EXHUST_STORE_LIST,
  GET_PLAN_STORE_HISTRY,
  SEARCH_PLAN_STORE_HISTRY,
  ALL_STORE_HISTRY,
  SAVE_CASHBACKAPI_ENABLED
};
